import { render, staticRenderFns } from "./HeaderBack.vue?vue&type=template&id=bbb71e44&web=true&"
import script from "./HeaderBack.vue?vue&type=script&lang=js&"
export * from "./HeaderBack.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBack.vue?vue&type=style&index=0&id=bbb71e44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports